import { Typography } from "components/atoms";
import "./index.scss";
import classNames from "classnames";

interface IProps {
  breadCrumbItems: string[] | undefined;
  activeItemIndex: number;
}

export const FormBreadCrumbSection = ({
  breadCrumbItems,
  activeItemIndex,
}: IProps) => {
  return (
    <div className="breadcrumb-items-wrapper">
      {breadCrumbItems?.map((title: string, index: number) => (
        <div
          className={classNames({
            "breadcrumb-item": true,
            "is-active": index === activeItemIndex,
            "has-arrow-end": index + 1 !== breadCrumbItems.length,
            "has-arrow-begin": index + 1 === breadCrumbItems.length,
            "has-arrow-both-end":
              index > 0 && index + 1 !== breadCrumbItems.length,
            "most-left-item": index === 0,
            "most-right-item": index + 1 === breadCrumbItems.length,
          })}
          key={index}
        >
          <Typography
            label={title}
            variant="h7Book"
            styles="custom-breadcrumb-item-style"
          />
        </div>
      ))}
    </div>
  );
};
